<template>
  <router-link class="gallery-link" to="/home"> <!-- :to="link | setLink" -->
    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <img :src="image" alt="Avatar">
          <h2 class="flip-card-front-title clear">
            <slot></slot>
          </h2>
        </div>
        <div class="flip-card-back">
          <ul>
            <li>Migración</li>
            <li>Inmobiliario</li>
            <li>Judicial</li>
            <li>Penal</li>
          </ul>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ItemService',
  props: {
    image: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
  filters: {
    setLink(link) {
      return `/service/${link}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-link {
  width: 26%;
  margin: 10px;
  border-radius: 3px;
}

.flip-card {
  background-color: transparent;
  width: 100%;
  height: 225px;
  border-radius: 3px;
  perspective: 1000px; /* Remove this if you don't want the 3D effect */
  overflow: hidden;
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container
.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
*/

/* Position the front and back side */
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  img {
    width: 100%;
    height: 100%;
    -webkit-filter: brightness(50%) grayscale(30%);
    filter: brightness(50%) grayscale(30%);
    overflow: hidden;
  }

  .flip-card-front-title {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: Georgia, "Times New Roman", Times, serif;
    font-size: 2.5em;
    font-weight: normal;
  }
}

/* Style the back side */
.flip-card-back {
  color: #fff;
  background-color: #212121;
  transform: rotateY(180deg);
}
</style>
